<i18n src="./translations"></i18n>
<i18n src="Components/03-organisms/product-details-21/translations"></i18n>

<template>
  <div class="bundle-product" :class="classes" :data-preload="[$options.name]">
    <div class="bundle-product__image-container">
      <div
        class="bundle-product__images"
        role="button"
        tabindex="0"
        :aria-label="$t('bundle-product.view-details')"
        @click="productClick()"
        @keydown.enter.prevent="productClick()"
        @keydown.space.prevent="productClick()"
      >
        <AdvancedImage
          v-if="product.imageUrls && product.imageUrls.length"
          class="bundle-product__product-image"
          :src="product.imageUrls[0]"
          :config="{ q: 80, w: 180 }"
        />

        <NoImageSvg
          v-else
          class="bundle-product__no-image"
          :lazy="true"
          :inline="false"
        />
      </div>
    </div>

    <div class="bundle-product__content-container">
      <ProductInfoSections
        :product="product"
        variant="pdp"
        :car-limit="1000"
        :no-car-prepend="isCarSelected ? [] : [productQuantity]"
        is-title-hidden
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import globalMixin from 'Libs/mixins/globalMixin.js';
import AdvancedImage from 'Components/01-atoms/advanced-image/AdvancedImage.vue';
import ProductInfoSections from 'Src/components/02-molecules/product-info-sections/ProductInfoSections.vue';
import NoImageSvg from 'Components/00-generated/NoImageSvg.vue';

export default {
  name: 'BundleProduct',
  components: {
    AdvancedImage,
    ProductInfoSections,
    NoImageSvg,
  },
  mixins: [globalMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    amount: {
      type: Number,
      default: 0,
    },
    position: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isCarSelected() {
      return (
        this.product.pdpCarBar &&
        this.product.pdpCarBar.key &&
        this.product.pdpCarBar.key === 'SELECTED_CAR_OK'
      );
    },
    productQuantity() {
      const pieceTranslation =
        this.amount > 1
          ? this.$t('bundle-product.quantity.pieces')
          : this.$t('bundle-product.quantity.piece');

      return {
        label: this.$t('bundle-product.quantity.amount'),
        info: `${this.amount} ${pieceTranslation}`,
        isTop: true,
      };
    },
  },
  methods: {
    ...mapActions('dataLayer', ['trackProductClick']),
    productClick() {
      this.trackProductClick({
        product: this.product,
        position: this.position,
      }).finally(() => {
        if (this.product.productUrl) {
          window.location.href = this.product.productUrl;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'variables/breakpoints';
@import 'mixins';

.bundle-product {
  display: flex;
  flex-wrap: wrap;
  border-radius: 8px;

  @media #{$_mediaSDown} {
    padding-left: 0;

    border: 0;
  }

  @media #{$_mediaLUp} {
    padding: 0 var(--space-2) var(--space-2);
  }

  &__no-image {
    max-height: 126px;
  }

  &__image-container {
    position: relative;
    width: 25%;
    max-width: 150px;
    padding-right: var(--space-1--half);
  }

  &__content-container {
    padding: var(--space-0--half) 0 var(--space-1--half) 0;
    text-align: left;
    width: 75%;
    max-width: 600px;
  }

  &__product-image {
    max-height: 140px;
    max-width: 100%;
    cursor: pointer;
    height: auto;
    width: auto;

    &:hover,
    &.active {
      ::v-deep .img {
        @media #{$_mediaMUp} {
          transform: scale(1.06);
        }
      }
    }

    ::v-deep .img {
      transition: transform var(--time-S) ease-in-out;
      max-height: 140px;
    }
  }

  &__images {
    display: flex;
    margin-top: 3px;
    flex-direction: column;
    align-items: center;
  }

  ::v-deep {
    .pdp-information-21 {
      &__headline {
        display: none;
      }

      &__wrapper {
        padding-left: 0;
      }
    }
  }
}
</style>
